import { render } from "./EmployeeDetailsPageAbsences.vue?vue&type=template&id=76b354f2"
import script from "./EmployeeDetailsPageAbsences.vue?vue&type=script&lang=ts"
export * from "./EmployeeDetailsPageAbsences.vue?vue&type=script&lang=ts"
script.render = render

export default script